
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../shared/_guards/auth.guard';
import { SalesInvoiceComponent } from './sales-invoice.component';


const routes: Routes = [
    { path: 'salesInvoice', pathMatch: 'full', component:  SalesInvoiceComponent, canActivate: [AuthGuard]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SalesInvoiceoutingModule { }


// WEBPACK FOOTER //
// ./src/app/sales-invoice/sales-invoice-routing.module.ts